import { Icon, IconButton, LinearProgress, Stack, Tooltip } from "@mui/material";
import MDDataGrid from "components/MDDataGrid/MDDataGrid";
import { useState } from "react";
import { useDispatch } from "react-redux";
import EmptyTableRowOverlay from "components/MDEmptyOverlay/EmptyTableRowOverlay";
import MDTypography from "components/MDTypography";
import DeleteDialog from "components/UIComponents/DeleteDialog";
import moment from "moment";
import { amountToShow } from "global/functions";
import { deleteBooting, getBootings } from "store/slice/bootingRevenue/bootingRevenueSlice";
import CreateBooting from "./CreateBooting";

const BootingTable = (props) => {
  const { bootingData, roleModules, placeId } = props;
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [bootingId, setBootingId] = useState();
  const [selectedBootingData, setSelectedBootingData] = useState();
  const dispatch = useDispatch();

  const handelDelete = () => {
    dispatch(deleteBooting({ bootingId }))
      .unwrap()
      .then((res) => {
        if (res?.success) {
          dispatch(getBootings(placeId));
          setDialogOpen(false);
        }
      })
      .catch((err) => console.error("Error deleting booting:", err));
  };

  const columnsData = [
    {
      field: "bootingDate",
      headerName: "Booting Date",
      width: 200,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption" sx={{ color: "black.light" }}>
          {moment(row.bootingDate).format("MM/DD/YYYY")}
        </MDTypography>
      ),
    },
    {
      field: "placeId",
      headerName: "Location",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption" sx={{ color: "black.light" }}>
          {row.placeId?.parkingCode}
        </MDTypography>
      ),
    },
    {
      field: "registerBooting",
      headerName: "Register Booting",
      width: 200,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption" sx={{ color: "black.light" }}>
          {row.registerBooting}
        </MDTypography>
      ),
    },
    {
      field: "registerBootingAmount",
      headerName: "Register Booting Amount",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption" sx={{ color: "black.light" }}>
          ${amountToShow(row.registerBootingAmount)}
        </MDTypography>
      ),
    },
    {
      field: "vipBooting",
      headerName: "VIP Booting",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption" sx={{ color: "black.light" }}>
          {row.vipBooting}
        </MDTypography>
      ),
    },
    {
      field: "vipBootingAmount",
      headerName: "VIP Booting Amount",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption" sx={{ color: "black.light" }}>
          ${amountToShow(row.vipBootingAmount)}
        </MDTypography>
      ),
    },
    {
      field: "totalBooting",
      headerName: "Total Booting",
      width: 150,
      editable: false,
      renderCell: ({ row }) => (
        <MDTypography display="block" variant="caption" sx={{ color: "black.light" }}>
          {row.vipBooting + row.registerBooting}
        </MDTypography>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: ({ row }) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          {roleModules.Booting_revenue_update && (
            <Tooltip title="Edit" placement="top" arrow>
              <IconButton
                onClick={() => {
                  setEditDialogOpen(true);
                  setBootingId(row._id);
                  setSelectedBootingData(row);
                }}
                color="success"
              >
                <Icon fontSize="small">edit</Icon>
              </IconButton>
            </Tooltip>
          )}
          {roleModules.Booting_revenue_delete && (
            <Tooltip title="Delete Booting" placement="top" arrow>
              <IconButton
                onClick={() => {
                  setDialogOpen(true);
                  setBootingId(row._id);
                }}
                color="error"
              >
                <Icon fontSize="small">delete</Icon>
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      ),
    },
  ];

  return (
    <>
      <MDDataGrid
        rows={bootingData ?? []}
        columns={columnsData}
        getRowId={(row) => row._id}
        pagination
        page={page}
        pageSize={pageSize}
        paginationMode="client"
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        disableSelectionOnClick
        components={{
          NoRowsOverlay: EmptyTableRowOverlay,
          LoadingOverlay: LinearProgress,
        }}
      />
      <CreateBooting
        isEdit
        bootingData={selectedBootingData}
        placeId={placeId}
        dialogOpen={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
      />
      <DeleteDialog
        dialogOpen={dialogOpen}
        onClose={() => setDialogOpen(false)}
        handelClick={handelDelete}
      />
    </>
  );
};

export default BootingTable;
